import React, { forwardRef } from 'react';
import QRCode from 'react-qr-code';

const CreatePDF = forwardRef(({ savedRegistrationNumbers }, ref) => {
  const validData = Array.isArray(savedRegistrationNumbers) 
    ? savedRegistrationNumbers.map(item => typeof item === 'string' ? JSON.parse(item) : item)
    : [];

  if (validData.length === 0) return <div ref={ref} />;
  
  return (
    <div ref={ref} style={{ backgroundColor: "white", width: "100%" }}>
      <style>{`
        @page { 
          size: A4; 
          margin: 0 !important; 
        }

        @media print {
          html, body {
            margin: 0 !important;
            padding: 0 !important;
            height: 100%;
            -webkit-print-color-adjust: exact;
          }

          .qr-page-container {
            display: grid !important;
            grid-template-columns: repeat(4, 38.1mm);
            grid-auto-rows: min-content; 
            gap: 2mm; 
            justify-content: center;
            padding: 10mm 0; 
            overflow: visible;
          }
          
          .qr-card {
            width: 38.1mm;
            height: 50.8mm;
            border: 0.5px solid #000;
            display: flex;
            flex-direction: column;
            padding: 2mm;
            box-sizing: border-box;
            break-inside: avoid;
            page-break-inside: avoid;
            page-break-after: auto;
          }

          .qr-page-container:after {
            content: none !important;
          }
        }

        .qr-page-container {
          display: grid;
          grid-template-columns: repeat(4, 38.1mm);
          gap: 5mm;
          padding: 20px;
          justify-content: center;
        }

        .qr-card {
          width: 38.1mm;
          height: 50.8mm;
          border: 1px solid #000;
          display: flex;
          flex-direction: column;
          padding: 2mm;
          box-sizing: border-box;
          background: #fff;
        }

        .top-info { font-family: Arial; margin-bottom: 1mm; }
        .qr-container { display: flex; align-items: center; justify-content: center; flex: 1; }
        .bottom-info { font-family: Arial; margin-top: 1mm; text-align: center; }
      `}</style>

      <div className="qr-page-container">
        {validData.map((item, index) => (
          <div key={index} className="qr-card">
            <div className="top-info">
              <div style={{ fontWeight: 'bold', fontSize: '10px' }}>{item.factory}</div>
              <div style={{ fontSize: '8px' }}>{item.route}</div>
            </div>

            <div className="qr-container">
              <QRCode value={item.regNo} size={85} level="L" />
            </div>

            <div className="bottom-info">
              <div style={{ fontWeight: 'bold', fontSize: '10px' }}>{item.regNo}</div>
              <div style={{ fontSize: '8px', whiteSpace: 'nowrap', overflow: 'hidden' }}>{item.name}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
});

export default CreatePDF;